import 'highlight.js/styles/atelier-lakeside-dark.css';
import 'highlight.js/styles/github.css';
export default {
    //highLight
    highLight() {
        //本地引入高亮主题色，动态创建link标签
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.setAttribute("class",'stylesheetClass');
        link.href =`${window.location.origin}/static/highLight/${ this.mavonCodestyle }.min.css?t=${ Date.now() }`;
        document.head.append(link);
        //本地引入highlight相关 css&js（mavon-editor内置highlight插件，都使用csdn方式引入，导致网路异常时加载不到资源，所以需要本地引入覆盖）；
        let linkMarkDown = document.createElement('link');
        let linkKatexcss = document.createElement('link');
        let scriptHighLight = document.createElement('script');
        let scriptKatexjs = document.createElement('script');
        linkKatexcss.rel = 'stylesheet';
        linkMarkDown.rel = 'stylesheet';
        scriptHighLight.type='text/javascript';
        scriptKatexjs.type='text/javascript';
        linkMarkDown.setAttribute('id','linkMarkDown');
        linkKatexcss.setAttribute('id','linkKatexcss');
        scriptHighLight.setAttribute('id','scriptHighLight');
        scriptKatexjs.setAttribute('id','scriptKatexjs');
        linkKatexcss.href =`${window.location.origin}/static/highLight/katex.min.css`
        linkMarkDown.href =`${window.location.origin}/static/highLight/github-markdown.min.css`
        scriptHighLight.src =`${window.location.origin}/static/highLight/highlight.min.js`
        scriptKatexjs.src =`${window.location.origin}/static/highLight/katex.min.js`
        document.head.append(linkKatexcss);
        document.head.append(linkMarkDown);
        document.head.append(scriptKatexjs);
        document.head.append(scriptHighLight);
    },


}



//////////////////
// WEBPACK FOOTER
// ./static/utils/highLightUtil.js
// module id = null
// module chunks = 